// App.js
import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './RouteLink';
import { Toaster } from 'react-hot-toast';

const router = createBrowserRouter(routes);

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster position="top-right" />
    </>
  );
}

export default App;
